import store from '@/store'

export default { 

    getToken() {
        return store.state.auth.token;
    },

};
